<template>

	<div>
		<img src="../assets/img/index/circle-purple.png" alt="" class="circle_purple">
		<div class="wrap">
			<div class="bg-lines">
				<div class="line line1"></div>
				<div class="line line2"></div>
				<div class="line line3"></div>
				<div class="line line4"></div>
				<div class="line line5"></div>
				<div class="line line6"></div>
			</div>

			<header class="header">

				<!--<img src="assets/img/index/circle-purple.png" alt="" class="circle_purple">-->

				<div class="container header__container">
					<a href="/" class="header__logo">
						<img src="../assets/img/logo.png" alt="">
					</a>
					<nav class="header__nav">
						<a href="daas.html" class="header__nav-link">DAAS</a>
						<a href="trade-in.html" class="header__nav-link">Trade IN</a>
						<a href="http://isurance.ru/" class="header__nav-link" target="_blank">ServicePack</a>
						<a href="#" class="header__nav-link">Вакансии</a>
						<a href="https://crm.isurance.ru" class="header__nav-link"
						   target="_blank">Войти&nbsp;в&nbsp;лк</a>
						<a href="contact.html" class="header__nav-link">Контакты</a>
					</nav>
					<div class="header__phone-holder">
						<a href="tel:+74951503494" class="header__phone">+7 (495) 150-34-94</a>
					</div>
				</div>
			</header>

			<div class="home">
				<div class="home__wrapper">
					<div class="home__title">Активация сервисной программы</div>
					<Validation></Validation>
				</div>
			</div>

			<div class="bottom-logo">
				<img src="../assets/img/logo-blue.png" alt="" class="bottom-logo__img">
			</div>
			<footer class="footer">

				<img src="../assets/img/index/circle-blue.png" alt="" class="circle__footer">

				<div class="container footer__container">
					<div class="footer__copyright">© 2018 Телекоминвест</div>
					<nav class="footer__nav">
						<a href="daas.html" class="footer__nav-link">DAAS</a>
						<a href="trade-in.html" class="footer__nav-link">Trade IN</a>
						<a href="http://isurance.ru/" class="footer__nav-link" target="_blank">ServicePack</a>
						<a href="#" class="footer__nav-link">Вакансии</a>
						<a href="https://crm.isurance.ru" class="footer__nav-link" target="_blank">Войти&nbsp;в&nbsp;лк</a>
						<a href="contact.html" class="footer__nav-link">Контакты</a>
					</nav>
					<div class="footer__phone">+7 (495) 150-34-94</div>
				</div>
			</footer>
		</div>
	</div>

</template>

<script>
	// @ is an alias to /src
	import Validation from '@/components/Validation.vue';

	export default {
		name: 'Home',
		components: {
			Validation
		}
	};
</script>


<style lang="scss">
	.home {
		position: relative;
		z-index: 2;
		padding: 50px;
		margin: 0;

		&__wrapper {
			max-width: 1206px;
			width: 100%;
			margin: 0 auto;
		}

		&__title {
			font-weight: 900;
			font-size: 40px;
			line-height: 48px;
			color: #210E4A;
			margin-left: 53px;
			margin-bottom: 50px;
		}
	}
</style>
